import React from 'react';
import PermessiNavigazioneService from '../../../services/api/permessi-navigazione.service';
import ModalForm from '../../../common/ModalForm';
import Table from '../../../common/TableComponent';
import getListActionsColumnDefs, { listActionsColumns } from '../../../config/table-columns/gestione-azioni';
import { addActionFormFields, editActionFormFields } from '../../../config/form-fields/gestione-azioni';
import { IFormField } from '../../../helpers/interfaces/generic';
import Swal from "sweetalert2";
import $ from 'jquery';
import EventBus from '../../../common/EventBus';

type Props = {};

type State = {
    formFields: IFormField[];
    formInitialValues: { [key: string]: any };
    showModal: boolean;
    modalType: string;
    modalTitle: string;
    actionsList: any[];
};

export default class GestioneAzioni extends React.Component<Props, State> {

    apiSubmit: any;

    constructor(props: Props) {
        super(props);
        this.state = {
            formFields: [],
            formInitialValues: {},
            showModal: false,
            modalType: '',
            modalTitle: '',
            actionsList: []
        };
    }

    async componentDidMount() {
        this.getActionsList();

        $('#table_actions').on('click', '.edit_btn', async (e: any) => {
            e.preventDefault();
            EventBus.dispatch("showLoader", { text: 'Caricamento dati...' });
            const id = $(e.currentTarget).data('id');

            try {
                const action = await PermessiNavigazioneService.getOneUserActions(id);
                this.setState({
                    formFields: editActionFormFields(),
                    formInitialValues: { id: action.id, code: action.code, name: action.name }
                }, () => {
                    this.apiSubmit = PermessiNavigazioneService.editUserAction;
                    this.setState({ showModal: true, modalType: 'edit', modalTitle: 'Modifica azione' });
                });
            } catch {
                Swal.fire({ title: 'Errore', text: 'Impossibile caricare l\'azione.', icon: 'error' });
            } finally {
                EventBus.dispatch("hideLoader");
            }
        });

        $('#table_actions').on('click', '.delete_btn', async (e: any) => {
            e.preventDefault();
            const id = $(e.currentTarget).data('id');
            Swal.fire({
                title: 'Confermi l\'eliminazione?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Conferma',
                cancelButtonText: 'Annulla'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await PermessiNavigazioneService.deleteUserAction(id);
                        window.location.reload();
                    } catch (error: any) {
                        const msg = error?.response?.data?.error?.description || 'Errore';
                        Swal.fire('Errore', msg, 'error');
                    }
                }
            });
        });
    }

    getActionsList() {
        EventBus.dispatch("showLoader", { text: 'Caricamento azioni...' });
        PermessiNavigazioneService.getAllUserActions()
            .then((response: any[]) => {
                this.setState({ actionsList: response });
            })
            .catch(() => {
                Swal.fire({ title: 'Errore', text: 'Impossibile caricare le azioni.', icon: 'error' });
            })
            .finally(() => EventBus.dispatch("hideLoader"));
    }

    openAddModale() {
        this.setState({
            formFields: addActionFormFields(),
            formInitialValues: {}
        }, () => {
            this.apiSubmit = PermessiNavigazioneService.addUserAction;
            this.setState({ showModal: true, modalType: 'add', modalTitle: 'Nuova azione' });
        });
    }

    closeModal() {
        this.setState({ showModal: false });
    }

    render() {
        const { formFields, formInitialValues, showModal, modalType, modalTitle, actionsList } = this.state;

        return <div className="custom-container">
            <div className="card">
                <div className="card-body">
                    <div className="form-group mb-3 d-flex justify-content-between align-items-center">
                        <h2 className="card-title">Elenco azioni</h2>
                        <button className="btn topic-empty-btn-color" onClick={() => this.openAddModale()}>
                            <span>Aggiungi azione</span>
                        </button>
                    </div>
                    <ModalForm
                        showModal={showModal}
                        modalTitle={modalTitle}
                        modalType={modalType}
                        formFields={formFields}
                        initialValues={formInitialValues}
                        apiSubmit={this.apiSubmit}
                        closeCallback={this.closeModal.bind(this)}
                        successAction={this.getActionsList.bind(this)}
                    />
                    <Table id="table_actions" columns={listActionsColumns}
                        columnDefs={getListActionsColumnDefs()} datas={actionsList} buttons={[]} />
                </div>
            </div>
        </div>;
    }
}
